<script>
    import TreeNode from "./components/TreeNode.svelte";
    import OPTS from './options'
</script>

<div class="panel panel-default">
    <div class="panel-body bg-secondary">
        <ul class="list-group list-group-flush">
            {#each OPTS.tree.children as child (child.path)}
                <TreeNode {...child} />
            {/each}
        </ul>
    </div>
</div>

<style>
    .panel {
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        border: none;
        background-color: transparent;
    }
</style>